export default __webpack_public_path__ + "static/media/issue_orange.774dd275.svg";